var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "ChannelIcon d-inline-block text-center" }, [
    _vm.type === "phone"
      ? _c("i", { staticClass: "fa fa-phone fa-lg" })
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "mobile"
      ? _c("i", { staticClass: "fa fa-mobile fa-lg" })
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "email"
      ? _c("i", { staticClass: "fa fa-envelope" })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }